import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/AC';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

export function getInfoAC() {
    return get(`${url}/info`);
}

/**
 * 年金給付方式列表
 */
export function getPayWayInfo() {
    return get(`${url}/payWayInfo`);
}

/**
 * 年金給付期間列表
 */
export function getPayPeriodInfo() {
    return get(`${url}/payPeriodInfo`);
}

/**
 * 年金保證期間列表
 */
export function getEnsurePeriodInfo() {
    return get(`${url}/ensurePeriodInfo`);
}

/**
 * sumbit
 */
export function submitAC(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
